import {useApiClient} from "./client";

export function useSettingsApi() {
	const api = useApiClient();
	return {
		listSettings: () => api.get("/api/v2/settings"),
		updateSetting: (key: string, value: string) => api.put("/api/v2/settings/{key}", {path: {key}, query: {value}}),
	};
}
